"use client";

import { useEffect, useRef } from "react";
import ImageWithBasePath from "@/components/image-with-base-path";
import { Link } from "react-router";

const ExpertsSection = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const items = section.querySelectorAll(".testimonial-item-fifteen");

    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add("is-visible");
              }, index * 190);
            });

            obs.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        threshold: 0.1,
      }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <section className="section testimonial-section-fifteen">
        <div className="container">
          <div
            className="section-header section-header-fifteen text-center wow fadeInUp"
            data-wow-duration="2s"
          >
            <div>
              <div className="section-sub-title">Our Experts</div>
              <h2 className="section-title">
                Hear From the People Who <br /> Have <span>Experienced</span>
              </h2>
            </div>
          </div>

          {/* Animated Items Wrapper */}
          <div
            ref={sectionRef}
            className="testimonial-details-fifteen"
          >
            {/* Repeatable Item Component */}
            {[
              {
                img: "user-lg-1.jpg",
                name: "Rudy Novack",
                location: "Canada",
                text: "Therapy helped me manage anxiety and improve emotional wellbeing. practical guidanc carefully, and created a safe space. I now feel confident, balanced, and stronger.",
              },
              {
                img: "user-lg-2.jpg",
                name: "Emma Richardson",
                location: "USA",
                text: "Counseling sessions helped me overcome depression and stress. I gained clarity, coping strategies, and emotional support. Now I feel motivated, hopeful, and mentally stronger.",
              },
              {
                img: "user-lg-3.jpg",
                name: "Olivia Bennett",
                location: "Germany",
                text: "The supportive environment made opening up easier. I learned techniques to manage panic attacks and negative thoughts. I feel calmer, positive, and emotionally stable.",
              },
              {
                img: "user-lg-4.jpg",
                name: "Rudy Novack",
                location: "Canada",
                text: "Therapy helped me manage anxiety and improve emotional wellbeing. The therapist provided practical guidance and created a safe space.",
              },
              {
                img: "user-lg-5.jpg",
                name: "Sophia Martinez",
                location: "Spain",
                text: "Professional and compassionate support helped me overcome emotional challenges. The experience truly changed my life.",
              },
              {
                img: "user-lg-6.jpg",
                name: "Liam Connor",
                location: "Canada",
                text: "The personalized therapy sessions helped me understand my emotions and improve relationships. I now feel more stable and optimistic.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`testimonial-item-fifteen item-${index + 1}`}
              >
                <div className="testimonial-author-img">
                  <ImageWithBasePath
                    src={`assets/img/users/${item.img}`}
                    alt={item.name}
                    className="img-fluid"
                  />
                </div>

                <div className="star-rating">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fas fa-star" />
                  ))}
                </div>

                <p className="description">{item.text}</p>

                <div className="author-name">
                  <div>
                    <Link to="#" className="name">
                      {item.name}
                    </Link>
                    <p className="location">{item.location}</p>
                  </div>

                  <ImageWithBasePath
                    src="assets/img/icons/quatation-icon-1.svg"
                    alt="quotation"
                    className="img-fluid"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ExpertsSection;